import { Badge } from '@tempo-io/sui-badge';

export type ItemStatusBadgeProps = Omit<React.ComponentProps<typeof Badge>, 'children'> & {
  color: string;
  label: string;
};

export const ItemStatusBadge = ({ color, label, style, ...props }: ItemStatusBadgeProps) => (
  <Badge {...props} style={{ color: '#fff', backgroundColor: `#${color}`, ...style }}>
    {label}
  </Badge>
);
